// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".newPlaylist_root__3EWkF {\n  width: 100%;\n  padding: 0 0 0 20px;\n  box-sizing: border-box;\n  height: calc(100vh - 286px); }\n  .newPlaylist_root__3EWkF .newPlaylist_container__2UbzP {\n    display: flex; }\n  .newPlaylist_root__3EWkF .newPlaylist_tracks__cGTje {\n    width: calc(100% - 391px); }\n\n.newPlaylist_notice__3j1xO {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column; }\n", ""]);
// Exports
exports.locals = {
	"root": "newPlaylist_root__3EWkF",
	"container": "newPlaylist_container__2UbzP",
	"tracks": "newPlaylist_tracks__cGTje",
	"notice": "newPlaylist_notice__3j1xO"
};
module.exports = exports;
